import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";


interface TVChartCardProps {
  title: string;
  total: number;
  color: string;
  children: React.ReactNode;
}

const TVChartCard: React.FC<TVChartCardProps> = ({
  title,
  total,
  color,
  children,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        p: 3,
        borderRadius: 4,
        backgroundColor: colors.primary[900],
        border: "2px solid",
        borderColor: colors.primary[800],
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "8px",
          height: "100%",
          backgroundColor: color,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          mb: 2,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: colors.grey[300],
            letterSpacing: "0.05em",
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h1"
          sx={{ fontWeight: 900, color: color, lineHeight: 1 }}
        >
          {total.toLocaleString()}
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default TVChartCard;